var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notfound-bd"},[_vm._m(0),_c('p',[_vm._v(_vm._s(_vm.$t('login_notfound.ymwzdoqjcnsrdwzsfzq')))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require("../../images/layout/404.png"),"alt":""}})])
}]

export { render, staticRenderFns }